<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/orcamentos-e-pacotes/inserir" label="Novo"
							icon="pi pi-plus" class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="listaOrcamentos" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['numeroOrcamento', 'dataOrcamento', 'interessado.nome', 'validadeProposta',
					'tipo', 'status']" responsiveLayout="stack" styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-end flex-column sm:flex-row">
						<div class="p-fluid">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="numeroOrcamento">
							Nº Proposta
							<p-sortIcon field="numeroOrcamento">
							</p-sortIcon>
						</th>
						<th pSortableColumn="dataOrcamento">
							Data Proposta
							<p-sortIcon field="dataOrcamento">
							</p-sortIcon>
						</th>
						<th pSortableColumn="interessado.nome">
							Interessado
							<p-sortIcon field="interessado.nome">
							</p-sortIcon>
						</th>
						<th pSortableColumn="valorProposta">
							Valor
							<p-sortIcon field="valorProposta">
							</p-sortIcon>
						</th>
						<th pSortableColumn="status">
							Status
							<p-sortIcon field="status">
							</p-sortIcon>
						</th>
						<th style="text-align: center;">
							<div>
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{item.numeroOrcamento}}
						</td>
						<td>
							{{item.dataOrcamento | date:'dd/MM/yyyy'}}
						</td>
						<td>
							{{ item.interessado.nome }}
						</td>
						<td>
							{{ item.valorProposta | currency:'BRL' }}
						</td>
						<td>
							{{ item.tipo}} - {{ item.status}}
						</td>
						<td style="text-align: center;">
							<div>
								<button *ngIf="permissaoDetalhar" pButton pRipple
									pTooltip="Detalhar" icon="pi pi-eye" class="p-button-info mr-2 mb-2"
									(click)="redirecionarPagina('/apps/orcamentos-e-pacotes/detalhar/' + item.id )"></button>
								<button *ngIf="habilitarEditar(item)" pButton pRipple pTooltip="Editar" icon="pi pi-pencil"
									class="p-button-success mr-2 mb-2"
									(click)="redirecionarPagina('/apps/orcamentos-e-pacotes/editar/' + item.id )"></button>
								<button *ngIf="habilitarExcluir(item)" pButton pRipple pTooltip="Excluir" icon="pi pi-trash"
									class="p-button-danger mr-2 mb-2 sm" (click)="excluir(item.id)"></button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando Orçamentos e pacotes. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>